import React from 'react';

// Minimalist line-art icons for pack formats — sketch the silhouette
export const PackIcon = ({ formatId, size = 56, stroke = 1.4 }) => {
  const s = stroke;
  const view = { viewBox: '0 0 64 64', width: size, height: size, fill: 'none', stroke: 'currentColor', strokeWidth: s, strokeLinejoin: 'round', strokeLinecap: 'round' };
  const path = (() => {
    switch (formatId) {
      case 'FLEX-PP':
        return <><path d="M14 10h36v44H14z" /><path d="M14 14h36M14 50h36" strokeDasharray="2 3" /></>;
      case 'FLEX-SUP':
        return <><path d="M14 10h36v40c0 2-2 4-4 4H18c-2 0-4-2-4-4V10Z" /><path d="M14 12h36M18 54l4-4M46 54l-4-4" /></>;
      case 'FLEX-GUS':
        return <><path d="M16 8h32v48H16z" /><path d="M16 14l6 4-6 4M48 14l-6 4 6 4M16 50l6-4-6-4M48 50l-6-4 6-4" /></>;
      case 'FLEX-PMP':
        return <><path d="M14 10h36v44H14z" /><circle cx="46" cy="14" r="1.2" /></>;
      case 'FLEX-SAC':
        return <><path d="M10 22h44v20H10z" /><path d="M10 22l-2-3M54 22l2-3M10 42l-2 3M54 42l2 3" /></>;
      case 'FLEX-FLOW':
        return <><path d="M8 18h48v28H8z" /><path d="M8 18l-4 14 4 14M56 18l4 14-4 14" /></>;
      case 'FLEX-BAG':
        return <><path d="M16 8h32v8H16z" /><path d="M16 16h32v40H16z" strokeDasharray="2 3" /></>;
      case 'FLEX-STICK':
        return <><path d="M28 6h8v52h-8z" /><path d="M28 6l-2-2 12 0-2 2M28 58l-2 2 12 0-2-2" /></>;
      case 'RIGID-CBOX':
      case 'RIGID-TUCK':
        return <><path d="M14 14h36v36H14z" /><path d="M14 14l8-6h28l8 6M50 50l8 6h-44l8-6" /></>;
      case 'RIGID-SLEEVE':
        return <><path d="M10 22h44v20H10z" /><path d="M14 22v20M50 22v20" /></>;
      case 'RIGID-TIN':
        return <><rect x="16" y="14" width="32" height="36" /><path d="M16 18h32M16 46h32" /></>;
      case 'RIGID-CAN':
        return <><rect x="20" y="10" width="24" height="44" rx="2" /><ellipse cx="32" cy="10" rx="12" ry="3" /></>;
      case 'RIGID-PCAN':
        return <><rect x="20" y="10" width="24" height="44" /><path d="M20 18h24" /></>;
      case 'RIGID-TRAY':
        return <><path d="M10 24h44l-4 18H14z" /><path d="M10 24l-2-4h48l-2 4" /></>;
      case 'RIGID-CLAM':
        return <><path d="M10 18h44v14H10zM10 32h44v14H10z" /></>;
      case 'BOTTLE-CONT':
        return <><path d="M26 8h12v10c4 2 6 6 6 12v22c0 2-2 4-4 4H24c-2 0-4-2-4-4V30c0-6 2-10 6-12V8Z" /><path d="M20 32h24" /></>;
      case 'BOTTLE-FB':
        return <><path d="M26 8h12v10c4 2 6 6 6 12v22c0 2-2 4-4 4H24c-2 0-4-2-4-4V30c0-6 2-10 6-12V8Z" /><path d="M22 30h20v18H22z" /></>;
      case 'BOTTLE-FRONT':
        return <><path d="M26 8h12v10c4 2 6 6 6 12v22c0 2-2 4-4 4H24c-2 0-4-2-4-4V30c0-6 2-10 6-12V8Z" /><path d="M22 34h20v14H22z" /></>;
      case 'BOTTLE-NECK':
        return <><path d="M26 8h12v10c4 2 6 6 6 12v22c0 2-2 4-4 4H24c-2 0-4-2-4-4V30c0-6 2-10 6-12V8Z" /><path d="M22 18h20v6H22z" /></>;
      case 'JAR-WRAP':
        return <><rect x="18" y="14" width="28" height="40" rx="2" /><path d="M18 22h28" /></>;
      case 'JAR-TOP':
        return <><circle cx="32" cy="32" r="20" /><circle cx="32" cy="32" r="14" /></>;
      case 'TUBE-CRIM':
        return <><rect x="20" y="14" width="24" height="36" rx="3" /><path d="M20 14l-4-4 32 0-4 4" /></>;
      case 'PAPER-WRAP':
        return <><path d="M10 18h44v28H10z" /><path d="M22 18v28M42 18v28" strokeDasharray="2 3" /></>;
      case 'PAPER-BAG':
        return <><path d="M16 8h32v48H16z" /><path d="M16 18l8-4 16 0 8 4" /></>;
      case 'BOARD-BOX':
        return <><path d="M10 22h44v32H10z" /><path d="M10 22l4-8h36l4 8" /></>;
      case 'PAPER-CONE':
        return <><path d="M14 14h36L36 56h-8L14 14z" /></>;
      case 'PAPER-CART':
        return <><path d="M14 22h36v34H14z" /><path d="M14 22l18-12 18 12" /></>;
      case 'MULTI-SHRINK':
        return <><rect x="10" y="16" width="44" height="30" /><path d="M22 16v30M42 16v30" /></>;
      case 'MULTI-TRAY':
        return <><path d="M10 30h44v18H10z" /><path d="M14 30v-6M50 30v-6" /></>;
      case 'MULTI-GIFT':
        return <><rect x="10" y="22" width="44" height="28" /><rect x="10" y="18" width="44" height="6" /><path d="M32 18v32" /></>;
      case 'MULTI-SLEEVE':
        return <><path d="M14 24h36v16H14z" /><path d="M22 14l-8 10M50 24l-8-10M14 40l8 10M50 40l-8 10" strokeDasharray="2 3" /></>;
      default:
        return <rect x="14" y="14" width="36" height="36" />;
    }
  })();
  return <svg {...view}>{path}</svg>;
};
